export type CustomError = {
  data: {
    [key: string]: string[];
  };
};

export const isCustomError = (
  item: CustomError | unknown,
): item is CustomError => {
  return (item as CustomError).data !== undefined;
};

export const getErrorMessage = (e: unknown) => {
  let errorMessage = "Une erreur est survenue";
  if (isCustomError(e)) {
    const firstErrorMessage = Object.values(e.data)?.[0]?.[0];
    if (firstErrorMessage) {
      errorMessage = firstErrorMessage;
    }
  }
  return errorMessage;
};
